module.exports = ".previous {\r\n    color: blue;\r\n    cursor: pointer;\r\n    text-decoration: underline;\r\n}\r\n\r\n.backHeader {\r\n    margin-top: 59px;\r\n    text-align: right;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/mywallet/walletoption/walletoption.component.css
// module id = ./src/app/mywallet/walletoption/walletoption.component.css
// module chunks = main